// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spin-window {
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 2;
  transform-origin: 50% 50%;
  max-width: 100%;
}
.spin-window-container {
  position: absolute;
  margin-top: 20px;
  background-color: #1d1d1d;
  width: 90%;
  border-radius: 15px;
  z-index: 2;
  padding: 15px;
  overflow: hidden;
}

.spin-window-spin-text {
  font-family: "Press Start 2P", system-ui;
  transform: translateY(2px);
  text-align: center;
  font-size: 18px;

  background: linear-gradient(
    to right,
    #363636 20%,
    rgb(110, 110, 110) 40%,
    rgb(255, 255, 255) 44%,
    rgb(255, 255, 255) 48%,
    rgb(63, 63, 63) 60%,
    #363636 80%
  );
  background-size: 200% auto;
  padding-left: 15px;
  font-weight: 600;
  color: #000;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  animation: shine 1s linear infinite;
}

@keyframes shine {
  to {
    background-position: 200% center;
  }
}

.spin-window-luck-text {
  font-size: 20px;
  font-weight: 600;
  text-align: end;
  padding-right: 10px;
  width: 100%;
  color: yellow;
  animation: text-wiggle 0.2s linear infinite;
}

@keyframes text-wiggle {
  0% {
    transform: translateY(-3px) translateX(3px);
  }
  25% {
    transform: translateY(3px) translateX(-1px);
  }
  50% {
    transform: translateY(-2px) translateX(3px);
  }
  75% {
    transform: translateY(2px) translateX(4px);
  }
  100% {
    transform: translateY(-3px) translateX(3px);
  }
}
.spin-window-auras-container {
  border-radius: 8px;
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
  gap: 5px;
}

.spin-window-auras-container::after {
  content: "";
  height: 180px;
  width: 2px;
  background-color: white;
  position: absolute;
}

.spin-window-auras {
  border-radius: 8px;
  display: flex;
  will-change: transform;
  gap: 6px;
}

.spin-window-aura {
  overflow: hidden;
  border-radius: 12px;
  padding: 4px;
  position: relative;
  height: 180px;
  width: 120px;
  background-color: rgb(0, 0, 0);
  flex-shrink: 0;
}
.a-top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 1);
  background-color: #00000052;
  border-radius: 8px;
  padding: 5px;
  height: 60px;
  text-align: center;
}

.a-name {
  font-size: 12px;
  font-weight: 700;
}
.a-probability {
  font-weight: 400;
}
.glowing-bg-star {
  position: absolute;
  width: 250px;
  opacity: 0.2;
  transform: translateX(0px) translateY(0px);
}

.show-win {
  position: relative;
  display: flex;
  justify-content: center;
  z-index: 5;
}

.show-win-backdrop {
  position: absolute;
  left: 0;
  top: 0;
  background-color: #000000a6;
  width: 100vw;
  height: 100vh;
  z-index: 2;
}
.show-win-container {
  display: flex;
  transform-origin: 50% 50%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  margin-top: 5%;
  border-radius: 12px;
  position: absolute;
  z-index: 2;
  overflow: hidden;
  background-color: #000000;
}
.show-win-name {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 100%;
}
.show-win-probability {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #47474793;
  width: 100%;
  text-align: center;
  height: 40px;
}
.show-win-image-container {
  padding: 30px;
  height: 35vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.win-image {
  width: 90%;
}
.win-glowing-bg-star {
  position: absolute;
  z-index: -1;
  width: 120%;
  opacity: 0.8;
  animation: rotating-star 5s linear infinite;
}
@keyframes rotating-star {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.show-win-new {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgb(172, 228, 68);
  color: #000;
  font-weight: 700;
  font-size: 14px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/AuraSpin.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;;EAEf;;;;;;;;GAQC;EACD,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;;EAEpC,mCAAmC;AACrC;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;AACF;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".spin-window {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  z-index: 2;\r\n  transform-origin: 50% 50%;\r\n  max-width: 100%;\r\n}\r\n.spin-window-container {\r\n  position: absolute;\r\n  margin-top: 20px;\r\n  background-color: #1d1d1d;\r\n  width: 90%;\r\n  border-radius: 15px;\r\n  z-index: 2;\r\n  padding: 15px;\r\n  overflow: hidden;\r\n}\r\n\r\n.spin-window-spin-text {\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  transform: translateY(2px);\r\n  text-align: center;\r\n  font-size: 18px;\r\n\r\n  background: linear-gradient(\r\n    to right,\r\n    #363636 20%,\r\n    rgb(110, 110, 110) 40%,\r\n    rgb(255, 255, 255) 44%,\r\n    rgb(255, 255, 255) 48%,\r\n    rgb(63, 63, 63) 60%,\r\n    #363636 80%\r\n  );\r\n  background-size: 200% auto;\r\n  padding-left: 15px;\r\n  font-weight: 600;\r\n  color: #000;\r\n  background-clip: text;\r\n  text-fill-color: transparent;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n\r\n  animation: shine 1s linear infinite;\r\n}\r\n\r\n@keyframes shine {\r\n  to {\r\n    background-position: 200% center;\r\n  }\r\n}\r\n\r\n.spin-window-luck-text {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  text-align: end;\r\n  padding-right: 10px;\r\n  width: 100%;\r\n  color: yellow;\r\n  animation: text-wiggle 0.2s linear infinite;\r\n}\r\n\r\n@keyframes text-wiggle {\r\n  0% {\r\n    transform: translateY(-3px) translateX(3px);\r\n  }\r\n  25% {\r\n    transform: translateY(3px) translateX(-1px);\r\n  }\r\n  50% {\r\n    transform: translateY(-2px) translateX(3px);\r\n  }\r\n  75% {\r\n    transform: translateY(2px) translateX(4px);\r\n  }\r\n  100% {\r\n    transform: translateY(-3px) translateX(3px);\r\n  }\r\n}\r\n.spin-window-auras-container {\r\n  border-radius: 8px;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  gap: 5px;\r\n}\r\n\r\n.spin-window-auras-container::after {\r\n  content: \"\";\r\n  height: 180px;\r\n  width: 2px;\r\n  background-color: white;\r\n  position: absolute;\r\n}\r\n\r\n.spin-window-auras {\r\n  border-radius: 8px;\r\n  display: flex;\r\n  will-change: transform;\r\n  gap: 6px;\r\n}\r\n\r\n.spin-window-aura {\r\n  overflow: hidden;\r\n  border-radius: 12px;\r\n  padding: 4px;\r\n  position: relative;\r\n  height: 180px;\r\n  width: 120px;\r\n  background-color: rgb(0, 0, 0);\r\n  flex-shrink: 0;\r\n}\r\n.a-top {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  color: rgba(255, 255, 255, 1);\r\n  background-color: #00000052;\r\n  border-radius: 8px;\r\n  padding: 5px;\r\n  height: 60px;\r\n  text-align: center;\r\n}\r\n\r\n.a-name {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n.a-probability {\r\n  font-weight: 400;\r\n}\r\n.glowing-bg-star {\r\n  position: absolute;\r\n  width: 250px;\r\n  opacity: 0.2;\r\n  transform: translateX(0px) translateY(0px);\r\n}\r\n\r\n.show-win {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  z-index: 5;\r\n}\r\n\r\n.show-win-backdrop {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  background-color: #000000a6;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 2;\r\n}\r\n.show-win-container {\r\n  display: flex;\r\n  transform-origin: 50% 50%;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 80%;\r\n  margin-top: 5%;\r\n  border-radius: 12px;\r\n  position: absolute;\r\n  z-index: 2;\r\n  overflow: hidden;\r\n  background-color: #000000;\r\n}\r\n.show-win-name {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 70px;\r\n  width: 100%;\r\n}\r\n.show-win-probability {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  background-color: #47474793;\r\n  width: 100%;\r\n  text-align: center;\r\n  height: 40px;\r\n}\r\n.show-win-image-container {\r\n  padding: 30px;\r\n  height: 35vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.win-image {\r\n  width: 90%;\r\n}\r\n.win-glowing-bg-star {\r\n  position: absolute;\r\n  z-index: -1;\r\n  width: 120%;\r\n  opacity: 0.8;\r\n  animation: rotating-star 5s linear infinite;\r\n}\r\n@keyframes rotating-star {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(-360deg);\r\n  }\r\n}\r\n.show-win-new {\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n  background-color: rgb(172, 228, 68);\r\n  color: #000;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
